import { Button } from "../ui/button";

interface FloatingButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

export default function FloatingButton({
  onClick,
  children,
}: FloatingButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      className="h-12 w-[41px] rounded-l-full rounded-r-none bg-black pr-1 shadow-lg transition-all duration-200"
      icon
    >
      {children}
    </Button>
  );
}
